import LazyInstagramFeed from "@/components/organisms/LazyInstagramField.vue";

export default defineNuxtPlugin((NuxtApp) => {
  NuxtApp.vueApp.component('InstagramFeed', LazyInstagramFeed);
});
